module.exports = __webpack_public_path__ + "images/78bbc3dfe1a09e375980863ba2a8c4ed-MSW_LineArt_Numbers(4)_slide19.png";